var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingApproval4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 326,
    viewBox: "0 0 247 326",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_9184)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4265_9184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 5,
    width: 98,
    height: 247
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.191 5.44897H239.999V251.347H142.191V5.44897Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4265_9184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.665 251.261L154.477 243.49C147.483 242.716 142.191 236.821 142.191 229.804V26.9915C142.191 19.9746 147.483 14.0801 154.477 13.3059L224.665 5.53441C232.845 4.62907 239.999 11.0139 239.999 19.2204V237.575C239.999 245.782 232.845 252.167 224.665 251.261",
    fill: "#1E2327"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.357 228.939L233.615 238.145L233.548 29.9753L145.301 39.1808L145.357 228.939Z",
    fill: "#00BEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.466 22.8079C183.342 22.8079 182.432 23.9077 182.432 25.2645C182.432 26.6213 183.342 27.7215 184.466 27.7215C185.589 27.7215 186.5 26.6213 186.5 25.2645C186.5 23.9077 185.589 22.8079 184.466 22.8079",
    fill: "#697079"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.2 24.0391C190.64 24.0391 190.186 24.5877 190.186 25.2643C190.186 25.9413 190.64 26.49 191.2 26.49C191.761 26.49 192.215 25.9413 192.215 25.2643C192.215 24.5877 191.761 24.0391 191.2 24.0391",
    fill: "#697079"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.696 233.773L191.676 199.336H173.804L172.271 231.734L156.048 230.054L156.02 180.811C156.015 173.019 162.384 166.719 170.199 166.785L196.363 167.009C204.34 167.077 210.662 173.742 210.286 181.687L207.741 235.446",
    fill: "#0F3541"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.775 90.8808L191.886 74.9338H179.003L178.115 93.8804C166.787 98.2277 165.27 102.758 165.27 111.538L207.44 108.457C207.44 99.6769 206.293 92.4039 192.775 90.8808",
    fill: "#774331"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.429 47.291C163.384 51.6931 167.045 60.5824 173.986 61.292C180.927 62.0017 179.14 52.6957 179.14 52.6957L166.429 47.291Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.915 64.7087C170.565 65.6717 168.85 70.5714 169.255 71.6402C169.659 72.7069 171.061 73.4031 172.232 73.562C172.557 80.5543 175.012 84.4866 179.461 84.9413C185.522 85.5611 191.848 80.147 192.995 68.9911C193.918 60.0165 192.091 54.3021 184.219 53.4973C176.883 52.7476 173.214 56.9552 170.915 64.7087Z",
    fill: "#774331"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.621 64.4227C187.307 60.5063 183.424 57.0079 178.36 56.4902C176.181 56.2676 174.377 56.0102 174.377 56.0102C165.927 55.1465 166.43 47.2909 166.43 47.2909C168.217 44.7371 172.226 47.2754 172.226 47.2754C172.226 47.2754 172.036 44.6709 174.148 44.887C181.769 48.0427 187.829 47.4065 192.748 48.9946C195.569 49.9056 197.396 52.6323 197.253 55.5861C197.031 60.1925 196.933 67.6339 193.35 76.1027C188.448 87.6892 177.003 86.1812 173.199 85.7698C172.339 85.6767 171.571 85.0789 171.405 84.232C169.518 74.6315 169.865 68.73 182.793 74.8995C185.007 71.0996 186.098 67.4067 186.621 64.4227Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.72 148.166C139.608 146.589 130.655 135.307 127.742 133.524C126.287 132.631 124.839 131.73 123.398 130.813L121.241 129.427L119.764 126.664C117.198 124.978 115.786 122.87 117.477 120.311C119.009 117.991 121.988 117.193 124.443 118.319L124.592 118.389L126.783 119.391L129.024 120.39C130.522 121.051 132.028 121.697 133.537 122.333C136.557 123.601 139.593 124.815 142.633 125.97C145.675 127.123 148.726 128.193 151.768 129.193C154.811 130.174 157.846 131.05 160.835 131.794L160.839 131.795C165.46 132.946 162.203 140.639 161.05 145.247C159.896 149.855 151.436 152.781 142.72 148.166",
    fill: "#774331"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.835 131.795L160.831 131.794C157.842 131.05 154.807 130.175 151.764 129.193C150.852 128.894 149.94 128.584 149.027 128.27C149.785 129.441 150.292 130.791 150.67 132.111C151.198 133.956 151.466 135.849 151.749 137.742C152.06 139.823 152.308 141.911 152.425 144.012C152.524 145.795 152.559 148.547 152.433 150.378C156.946 150.573 160.345 149.256 161.046 146.457C162.2 141.849 165.457 132.946 160.835 131.795",
    fill: "#B2E2F4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.803 128.691C155.864 134.227 155.864 150.279 155.864 150.279L169.213 138.462C169.213 138.462 162.539 116.076 155.864 120.009C155.864 125.757 151.803 128.691 151.803 128.691",
    fill: "#1A586B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.729 146.406L137.954 152.499C136.311 153.032 134.546 152.136 134.012 150.499L123.844 119.345C123.309 117.707 124.208 115.948 125.85 115.414L144.626 109.322C146.269 108.789 148.033 109.684 148.568 111.322L158.735 142.476C159.27 144.113 158.372 145.873 156.729 146.406",
    fill: "#9870B1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.865 140.882L136.056 147.31L126.875 119.18L146.683 112.752L155.865 140.882Z",
    fill: "#F4F8FA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.419 119.025C129.372 115.85 131.104 112.431 134.287 111.387V111.387C137.47 110.343 140.9 112.07 141.947 115.244L130.419 119.025Z",
    fill: "#D8E5E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.75 132.205C125.75 132.205 131.435 122.549 127.117 115.823C122.798 109.097 112.875 114.764 115.09 121.786C117.305 128.807 125.75 132.205 125.75 132.205",
    fill: "#774331"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.896 101.03C210.008 95.8135 202.187 91.9412 192.778 90.8806L178.015 100.699L178.117 92.9728C163.452 97.0174 155.867 105.778 155.867 114.559V182.024H210.477C210.477 167.921 210.854 156.281 211.421 146.751C211.421 146.751 228.644 136.797 228.574 136.224C228.397 134.755 228.005 133.284 227.468 131.959C223.892 122.816 216.101 103.298 213.896 101.03Z",
    fill: "#1A586B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.709 165.476L171.158 168.545L173.093 166.096L173.146 165.978C172.787 165.375 172.519 164.731 172.338 164.08L171.709 165.476Z",
    fill: "#EF5489"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.419 139.746C205.299 142.737 201.22 146.707 195.272 149.391C188.366 152.508 180.929 153.679 180.929 153.679C180.929 153.679 177.386 153.103 174.704 155.678C173.698 156.661 173.26 157.76 173.462 158.653C169.775 161.236 173.2 174.022 185.434 167.457C186.246 167.213 187.057 166.882 187.848 166.456L187.841 166.443L189.804 165.777C191.528 165.184 193.244 164.574 194.957 163.951C198.382 162.704 201.791 161.393 205.191 160.018C208.59 158.64 211.972 157.168 215.351 155.616C220.73 153.067 224.859 149.31 227.016 144.918C220.278 136.866 211.445 138.275 209.419 139.746",
    fill: "#774331"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.679 137.933C228.679 137.369 228.639 136.798 228.57 136.225C223.779 135.319 213.184 133.731 208.765 136.388L208.543 140.376C214.499 136.749 222.794 142.638 226.555 145.795C227.926 143.356 228.679 140.701 228.679 137.933",
    fill: "#FFCC66"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.535 145.884L181.919 146.503L176.799 157.823L174.979 158.126L180.535 145.884Z",
    fill: "#EF5489"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.574 87.0347C192.574 87.0347 187.721 93.0424 178.023 99.5772L178.114 90.8554C178.114 90.8554 175.281 99.4378 174.674 104.278L177.993 100.719L180.59 105.639C180.59 105.639 191.057 97.0176 195.608 91.2697C194.697 90.9674 192.574 87.0347 192.574 87.0347",
    fill: "#FFCC66"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.932 106.17L188.917 109.952L189.904 106.17H187.932Z",
    fill: "#6A707A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.168 119.632H186.667C185.979 119.632 185.416 119.071 185.416 118.385V109.081C185.416 108.395 185.979 107.834 186.667 107.834H191.168C191.856 107.834 192.419 108.395 192.419 109.081V118.385C192.419 119.071 191.856 119.632 191.168 119.632",
    fill: "#F4F8FA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.096 113.582H190.737V109.644H187.096V113.582Z",
    fill: "#C962A5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9843 322.501L81.5745 316.32C80.8884 316.004 80.2333 315.643 79.6119 315.24C78.8225 315.698 77.3682 316.5 76.2041 316.906C70.6028 318.862 64.3022 316.432 61.8273 311.045C61.362 310.032 61.0581 308.694 61.0086 307.501H73.4561C73.1404 306.632 72.901 305.733 72.7435 304.811H60.2461C61.0412 315.809 61.6718 324.985 61.6718 324.985H94.999V324.083C94.999 323.403 94.6027 322.786 93.9843 322.501",
    fill: "#19566A"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.0078 307.501C61.0573 308.694 61.3613 310.032 61.8265 311.045C64.3018 316.432 70.602 318.862 76.2037 316.907C77.3674 316.5 78.8217 315.698 79.6111 315.24C76.7463 313.383 74.6009 310.651 73.4554 307.501H61.0078Z",
    fill: "#C48C58"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.7455 304.81C72.6011 303.966 72.5233 303.104 72.5213 302.23L72.5216 302.141C72.522 302.032 72.5209 301.924 72.5236 301.816L72.5031 301.779L72.3661 299.094H59.832C59.9741 301.029 60.1135 302.945 60.2481 304.81H72.7455Z",
    fill: "#C48C58"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2735 322.501L35.8637 316.32C35.4688 316.139 35.0857 315.941 34.7117 315.729C33.9411 316.147 32.9888 316.623 32.1765 316.907C26.5751 318.862 20.2746 316.432 17.7997 311.045C17.3344 310.032 17.0304 308.694 16.981 307.501H27.7429C27.4268 306.633 27.1875 305.733 27.0299 304.811H16.2521C16.0441 315.666 15.9609 324.985 15.9609 324.985H49.2881V324.084C49.2881 323.403 48.8919 322.786 48.2735 322.501",
    fill: "#19566A"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9824 307.501C17.0319 308.694 17.3359 310.032 17.8011 311.045C20.2764 316.432 26.5766 318.862 32.1783 316.907C32.9903 316.623 33.9426 316.147 34.7132 315.729C31.4427 313.881 28.996 310.941 27.7444 307.501H16.9824Z",
    fill: "#C48C58"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0333 304.81C26.8792 303.908 26.8017 302.985 26.8101 302.048C26.8115 301.894 26.8216 301.738 26.8371 301.584L27.0859 299.094H16.3747C16.3313 301.019 16.2915 302.937 16.2559 304.81H27.0333Z",
    fill: "#C48C58"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4727 192.179V206.806C66.9258 206.923 67.4775 206.974 68.1558 206.974C72.0602 206.974 76.2352 199.948 76.2352 193.356C76.2352 192.937 76.2318 192.546 76.2247 192.179H66.4727Z",
    fill: "#C48C58"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9824 300.065C16.3325 290.399 17.0422 278.263 18.3544 263.365C16.1454 216.22 17.6104 162.222 25.7395 154.015H63.0505L67.651 195.373L71.2106 264.523L73.0265 300.065L59.4142 300.41C58.2289 290.951 57.1314 279.135 56.4049 264.66L43.4131 202.098L33.0382 265.262L29.0194 300.065H15.9824Z",
    fill: "#0F3541"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4265_9184",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 55,
    width: 87,
    height: 272
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 326.3H68.457H94.9998V55.4177H8V326.3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4265_9184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3613 170.659H71.1838V148.467H21.3613V170.659Z",
    fill: "#103541"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.352 122.744C66.639 108.958 58.0679 103.289 47.8246 101.421L47.1514 91.9778H37.3889L36.7156 101.421C26.4723 103.289 14.965 111.144 11.9727 123.013L71.352 122.744Z",
    fill: "#C48C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6895 122.744C68.7008 114.001 63.8219 108.526 58.2872 105.211C54.4721 107.824 48.9947 109.462 42.9069 109.462C36.5556 109.462 30.8707 107.677 27.0428 104.865C20.1135 108.59 13.6944 114.852 11.6369 123.013C11.6369 123.013 6.08776 141.615 8.69839 163.883C10.0019 174.999 21.8465 181.568 31.9167 176.66C41.897 171.795 45.0951 163.43 45.0951 163.43L38.8672 171.934L63.1153 170.659L67.6498 195.373H68.8523C77.65 195.373 84.7538 188.121 84.4777 179.338C83.7092 154.867 75.577 134.116 71.6895 122.744Z",
    fill: "#09BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0167 164.943H40.8556L39.4824 144.096H52.3898L51.0167 164.943Z",
    fill: "#F4F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3967 159.183L52.1915 147.113H39.6816L40.4768 159.183H51.3967Z",
    fill: "#C962A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.916 176.66C41.8967 171.796 45.0947 163.43 45.0947 163.43L40.5185 154.015L31.916 176.66Z",
    fill: "#09BFB1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.0969 163.43C47.9671 157.676 47.518 152.718 43.9056 149.797C40.2931 146.875 36.9691 149.804 33.5762 153.99L45.0969 163.43Z",
    fill: "#C48C58"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7905 144.365C52.7515 144.17 52.5791 144.028 52.3792 144.028H52.1577V143.509C52.1577 143.016 51.7577 142.616 51.2646 142.616H40.6086C40.1154 142.616 39.7155 143.016 39.7155 143.509V144.028H39.4937C39.2937 144.028 39.1217 144.17 39.0823 144.365L38.8672 145.441H53.006L52.7905 144.365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4601 55.9908C35.1005 56.457 32.5644 57.1873 30.6434 58.6045C29.7659 57.5502 28.3203 56.9528 27.0224 57.3737C27.8753 58.5354 28.123 60.0549 27.9881 61.4892C27.9456 61.9411 27.8653 62.3867 27.764 62.8283C27.7447 62.9064 27.7269 62.9858 27.7097 63.066C27.6826 63.1744 27.6523 63.2824 27.6223 63.3908C24.9705 64.639 22.6749 65.8299 23.6413 70.7106C24.6105 75.6059 28.766 84.3774 31.8182 88.2918L54.2051 75.1475C54.1879 73.5738 54.0495 72.0832 53.7858 70.7512C53.6155 69.8915 53.4667 69.0264 53.3215 68.1688C53.7051 68.8414 54.1255 69.694 54.5744 70.7772C57.6062 60.3682 47.5166 56.3401 47.5166 56.3401C45.3012 55.3121 42.1241 55.0694 37.4601 55.9908Z",
    fill: "#422727"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4753 96.5105C52.7499 95.2711 56.7852 86.1871 54.8374 76.3496C52.8896 66.5124 48.2006 61.8941 40.2748 63.4596C32.349 65.0252 29.1122 71.2091 31.06 81.0466C33.0078 90.8841 40.2007 97.7499 46.4753 96.5105Z",
    fill: "#BC8E60"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5706 84.0008C49.6362 83.9634 51.1848 83.0714 51.5389 81.7856C51.8762 80.5613 49.4706 75.3626 48.9852 74.3327C48.9057 74.1649 48.7041 74.093 48.5371 74.172C48.3688 74.251 48.2968 74.4514 48.3759 74.6195C49.5396 77.0865 51.0885 80.8854 50.8899 81.607C50.6566 82.454 49.6184 83.2002 49.2377 83.416C49.0761 83.5078 49.0195 83.7133 49.1118 83.8747C49.1851 84.0038 49.3312 84.0657 49.4696 84.0384C49.5039 84.0317 49.5383 84.0193 49.5706 84.0008Z",
    fill: "#472527"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.9145 61.3043C42.8835 60.6737 38.5751 61.3632 35.1845 63.63C31.7938 65.8972 28.9017 72.4827 29.7687 76.8613C31.9301 76.5596 35.8877 75.7595 37.9918 75.1823C39.4594 74.7797 40.9255 74.3038 42.2212 73.5064C43.5168 72.7087 44.6415 71.557 45.1573 70.1268C45.3357 71.3616 44.9479 72.6671 44.1237 73.6049C46.3013 73.0575 48.2412 71.6214 49.3985 69.6995C50.5558 67.7776 50.9168 65.393 50.3806 63.2152L46.9145 61.3043Z",
    fill: "#422727"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_9184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 326,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval4);
export default __webpack_public_path__ + "static/media/PendingApproval4.5d11589bbf037ff14e2b68c0a20cbcb1.svg";
export { ForwardRef as ReactComponent };